export const SUCCESS_CITY="SUCCESS_CITY";
export const FAILED_CITY="FAILED_CITY";
export const REQUST_CITY="REQUST_CITY";
